import { LOCALES } from "locales/locales";
import { create } from "zustand";
import { persist } from "zustand/middleware";
export var useLocaleStore = create()(persist(function (set) { return ({
    locale: LOCALES.ENGLISH,
    setLocale: function (newLocale) { return set({ locale: newLocale }); },
}); }, {
    name: "locale-storage",
}));
